export default "/imgs/investigation-06-mob.png"